import { mapState } from "vuex";

var Shops = {
  created: function() {
    this.fetchShops();
  },
  methods: {
    fetchShops() {
      this.$store.dispatch("shops/fetchShops");
    },
  },
  computed: {
    ...mapState("shops", ["shops", "selected"]),
  },
};

export default Shops;
